/**
 * @generated SignedSource<<ae6eedc4dd1f6a61048d88867248b74e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRow_packageDate$data = {
  readonly accommodationPrice: number | null;
  readonly duration: number | null;
  readonly end: string;
  readonly id: string;
  readonly start: string;
  readonly validTo: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity" | "PackageDateRowFlight_packageDate" | "PackageDateStatus_packageDate">;
  readonly " $fragmentType": "PackageDateRow_packageDate";
};
export type PackageDateRow_packageDate$key = {
  readonly " $data"?: PackageDateRow_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRow_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRow_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "validTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accommodationPrice",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRowFlight_packageDate"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateStatus_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "a06a62ce7f6af18aaaa858b65bb6e034";

export default node;
